import React, { lazy, Suspense } from 'react';

export const lazyLoad = (
  importFunc: any,
  selectorFunc: any,
  opts = { fallback: null },
) => {
  let lazyFactory = importFunc;

  if (selectorFunc) {
    lazyFactory = () =>
      importFunc().then((module: any) => ({
        default: selectorFunc(module),
      }));
  }

  const LazyComponent = lazy(lazyFactory);

  return (props: any) => (
    <Suspense fallback={opts.fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
